module.exports = __webpack_public_path__ + "static/media/ORTHODONTICS_MDS.e2dc9a4b.docx";